import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import React from "react";
import Select from 'react-select';
import ActionsContext from '../ActionsContextV2';
import _ from 'lodash';
import { Divider } from '@material-ui/core';
// import ActionsProjectSearchListItem from './ActionsProjectSearchListItem'
import SearchIcon from "@material-ui/icons/Search";
import { connect } from 'react-redux';
import { fetchProjects } from '../../../reduxActions/ProjectActions';
import ActionProjectSearchListItem from './ActionsProjectSearchListItem';

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: 'flex',
    padding: 0,
    height: 40,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: '18px',
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  }
});

const ListStyles = {
  groupLabel: {
    fontWeight: 500,
    color: 'black',
    fontSize: 14,
    paddingBottom: 10
  },
  valueLabel: {
    fontSize: 15,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '320px',
  }
};

const inputComponent = ({ inputRef, ...props }) => <div ref={inputRef} {...props} />;

const NoOptionsMessage = props => (
  <Typography
    color="textSecondary"
    className={props.selectProps.classes.noOptionsMessage}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
);

const formatGroupLabel = data => (
  <div>
    <div style={ListStyles.groupLabel}>
      <span>{data.label}</span>
    </div>
    <Divider />
  </div>
);

const Placeholder = props => (
  <Typography
    color="textSecondary"
    className={props.selectProps.classes.placeholder}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
);

const SingleValue = props => {
  const project = JSON.parse(props.children);

  if (!props.selectProps.inputValue && props.selectProps.menuIsOpen) {
    return null;
  }

  return (
    <div style={ListStyles.valueLabel}>
      {project.preferredName ? project.preferredName : project.name}
    </div>
  );
}

const ValueContainer = props => {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

const Menu = (props) => (
  <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
    {props.children}
  </Paper>
);

const Control = (props) => (
  <TextField
    fullWidth
    InputProps={{
      inputComponent,
      inputProps: {
        className: props.selectProps.classes.input,
        inputRef: props.innerRef,
        children: props.children,
        ...props.innerProps,
      },
    }}
    {...props.selectProps.textFieldProps}
  />
);

const DropdownIndicator = (props) => (
  <div style={{ paddingLeft: 10 }}>
    <SearchIcon />
  </div>
)



class ProjectLookupSelect extends React.Component {

  static contextType = ActionsContext;

  constructor(props) {
    super(props);

    this.state = {
      filteredProjects: [],
      searchTerm: '',
      selectedProject: null,
      menuIsOpen: false,

    }
  }



  componentDidMount() {
    this.filterProjects();
    this.props.fetchProjects();
  }

  filterProjects() {
    const projects = this.context.actionsRedux.projectFunctions;
    if (this.state.searchTerm) {
      this.setState({ filteredProjects: [...projects] });
    } else {
      const filteredProjects = projects.filter(project => project.name.includes(this.state.searchTerm));
      this.setState(filteredProjects);
    }
  }

  clearSearch() {
    const projects = this.context.actionsRedux.projectFunctions;
    this.setState({ filterProjects: [...projects], searchTerm: '' });
  }

  render() {
    const selectOption = (project) => {
      this.setState({ menuIsOpen: false });
      let selectedProject;
      try {
        let q = otherProjects.filter((item)=>{
            return item.value == project.id
        })

        if(!q.length){
          q = myProjects.filter((item)=>{
            return item.value == project.id
        })
        }

        selectedProject = JSON.parse(q[0].label);
        this.context.selectProject(selectedProject);
        this.setState({ selectedProject: selectedProject});
      } catch (e) {
        console.error('Error parsing project:', e);
      }
    };
    

    const components = {
      NoOptionsMessage,
      Control,
      Menu,
      // Option: ActionsProjectSearchListItem,
      Option: (props) => {
        return <ActionProjectSearchListItem {...props} selectOption={selectOption} />
      },
      Placeholder,
      SingleValue,
      ValueContainer,
      DropdownIndicator,
    };

    const customFilter = (option, inputValue) => {
      const label = option.data.label.toLowerCase();
    
      // If it's an option, check if its label matches the search term
      if (label.includes(inputValue.toLowerCase())) {
        return true;
      }
    
      // If the option is a group (has 'options' array), filter its sub-options
      if (option.data.options && option.data.options.length > 0) {
        // Filter sub-options based on search term
        const filteredSubOptions = option.data.options.filter(subOption =>{
          const jsonObject = JSON.parse(subOption.label);
          return jsonObject.name.toLowerCase().includes(inputValue.toLowerCase())
        }
        );
    
        // If any sub-option matches, include the group and its filtered options
        if (filteredSubOptions.length > 0) {
          // Update the group to include only the filtered sub-options
          option.data.options = filteredSubOptions;
          return true;  // Return true to include this group in the result
        }
      }
    
      return false;  // Return false to exclude if no match found
    };
    
    
    


    const projects = this.context.actionsRedux.projectFunctions;

    let myProjects = projects.filter(project => _.find(project.functions, { isAssigned: true }));
    let otherProjects = projects.filter(project => !_.find(project.functions, { isAssigned: true }));

    const jsonfyProject = (project) => {
      return {
        label: JSON.stringify(project),
        value: project.id
      };
    };

    myProjects = myProjects.map(jsonfyProject);
    otherProjects = otherProjects.map(jsonfyProject);

    const myProjectsTemp = this.props.projects.gbus?.map((item) => {
      const a = [];
    
      item.projects.map((project) => {
        const matchedProject = myProjects.find((b) => b.value === project.id);
    
        if (matchedProject) {  // Check if a match is found
          a.push(matchedProject);
        }
      });
    
      // Only return the object if 'a' is not empty
      if (a.length > 0) {
        a.sort()
        return { label: item.name, options: a };  // Return the result with 'label' and 'options'
      }
    
      // If 'a' is empty, do not return anything for this item
      return null;
    }).filter(item => item !== null); // Remove null entries from the array
    


    const otherProjectsTemp = this.props.projects.gbus?.map((item) => {
      const a = [];
    
      item.projects.map((project) => { 
        const matchedProject = otherProjects.find((b) => b.value === project.id);
    
        if (matchedProject) {  // Check if a match is found
          a.push(matchedProject);
        }
      });

    
      // Only return the object if 'a' is not empty
      if (a.length > 0) {
        a.sort()
        return { label: item.name, options: a };  // Return the result with 'label' and 'options'
      }
    
      // If 'a' is empty, do not return anything for this item
      return null;
    }).filter(item => item !== null); // Remove null entries from the array
       
    

    const projectGroupsNew = [];

    // Check if myProjectsTemp has any items, then add it to the projectGroupsNew
    if (myProjectsTemp?.length > 0) {
      projectGroupsNew.push({
        label: "My Projects",
        options: myProjectsTemp
      });
    }
    
    // Check if otherProjectsTemp has any items, then add it to the projectGroupsNew
    if (otherProjectsTemp?.length > 0) {
      projectGroupsNew.push({
        label: "Other Projects (Read-Only)",
        options: otherProjectsTemp
      });
    }

    const selectedValue = this.context.actionsRedux.selectedProject ? jsonfyProject(this.context.actionsRedux.selectedProject) : undefined;

    const { classes, theme } = this.props;
    const selectStyles = {
      menuList: base => ({
        ...base,
        maxHeight: window.innerHeight - 300
      }),
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };

    return (
      <div>
        <Select
          value={selectedValue}
          inputValue={this.state.searchTerm}
          classes={classes}
          styles={selectStyles}
          options={projectGroupsNew} // Using nested structure with categories and subcategories
          formatGroupLabel={formatGroupLabel}
          components={components}
          placeholder="Search Projects"
          onInputChange={(searchTerm) => {
            if (!searchTerm) {
              this.clearSearch();
            } else {
              this.setState({ searchTerm })
              this.filterProjects()
            }
          }}
          filterOption={customFilter} // Use the custom filter here
          menuIsOpen={this.state.menuIsOpen} // Manage the open state of the dropdown
          onMenuClose={() => this.setState({ menuIsOpen: false })} // Close on menu close
          onMenuOpen={() => this.setState({ menuIsOpen: true })} // Open on menu open
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { projects } = state;
  return { reduxStore: projects, projects };
};

ProjectLookupSelect = withStyles(styles, { withTheme: true })(ProjectLookupSelect);
export default connect(mapStateToProps, { fetchProjects })(ProjectLookupSelect);
